import { render, staticRenderFns } from "./AccidentesEIncidentes.vue?vue&type=template&id=30dcad5e&"
import script from "./AccidentesEIncidentes.vue?vue&type=script&lang=js&"
export * from "./AccidentesEIncidentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports